<template>
  <div class="container container-nav new-search">
    <van-nav-bar
      title="搜索"
      left-arrow
      class="nav-bar-primary"
      ref="titleNav"
      :border=false
      :z-index=999
      @click-left="goBack"/>
    <form action="/" class="search-form">
      <van-search
        placeholder="岗位名、岗位id、门店名"
        show-action
        shape="round"
        id="pickoversearch"
        v-model="keyWord"
        ref="searchNav"
        @search="getAllList()"
        class="ds-search-wrap">
        <div slot="action" class="c-white" @click="getAllList()" v-if="showInit">搜索</div>
        <div slot="action" class="c-white" @click="cancel" v-else>取消</div>
      </van-search>
    </form>
    <van-tabs v-model="active" @click="tabChange" class="srarchTabs" v-if="!showInit">
        <van-tab title="门店">
          <p class="p-normal bg-white c-gray f12" v-if="mapAddress&&!showInit">在[<span class="c-red">{{mapAddress.showAddress}}</span>]为您找到<span class="c-red">{{showSearchTotal}}</span>条记录</p>
        <p class="p-normal bg-white c-gray f12" v-if="!mapAddress&&!showInit">在[<span class="c-red">上海</span>]为您找到<span class="c-red">{{showSearchTotal}}</span>条记录</p>
        </van-tab>
        <van-tab title="岗位">
          <p class="p-normal bg-white c-gray f12" v-if="mapAddress&&!showInit">在[<span class="c-red">{{mapAddress.showAddress}}</span>]为您找到<span class="c-red">{{showSearchTotal}}</span>条记录</p>
        <p class="p-normal bg-white c-gray f12" v-if="!mapAddress&&!showInit">在[<span class="c-red">上海</span>]为您找到<span class="c-red">{{showSearchTotal}}</span>条记录</p>
        </van-tab>
    </van-tabs>
    <section class="ds-search-content" :class="{'search-show-history':showInit, 'search-un-show-history':!showInit, 'ds-search-content-cale':showCaleInit}" ref="searchContent">
      <div class="p-normal" v-if="showInit">
        <h3 class="f14 f-b pb16 clearfix">
          <span class="fl">历史记录</span>
          <span class="fr icon icon-lajixiang f16 c-666" @click="delHis"></span>
        </h3>
        <div class="ds-search-list">
          <span v-for="(item,index) in hisList" :key="index" @click="clickKey(item)">{{item.SearchKey}}</span>
        </div>
      </div>
        <van-list class="search-content-pull-active" v-if="this.pickStatus === 1" v-model="loading" :finished="finished" :immediate-check="false" @load="getList()">
          <recruit-item v-for="(item,index) in list" :key="index" :item="item" :mapAddress="mapAddress" @confirm="onConfirm"></recruit-item>
        </van-list>
        <blank-tip tip="抱歉，无匹配内容~" v-if="!showInit&&!loading&&empty===10&&pickStatus===1"></blank-tip>
        <van-list class="search-content-pull-active" v-if="this.pickStatus === 0" v-model="shoploading" :finished="shopfinished" :immediate-check="false" @load="getShopList()">
          <shop-item v-for="(item,index) in shoplist" :key="index" :item="item" :mapAddress="mapAddress" :searchItem="searchItem"></shop-item>
        </van-list>
    </section>
        <blank-tip tip="抱歉，无匹配内容~" v-if="!showInit&&!shoploading&&shopempty===10&&pickStatus===0"></blank-tip>
    <!--  生成海报  -->
    <div id="share" style="position:fixed;right:-9999px;width:100%;top:0;">
      <div class="poster-title" style="border-radius:0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm"/>
      </div>
      <info :recruit="recruitItem" :showShare="true">
        <template #shareImg>
        <div class="txt-r">
        <img :src="codeData" @load="initCanvas" @error="initCanvas" class="qr pr25 pb10"/>
      </div>
      </template>
      </info>
    </div>
    <!--  生成海报  -->
    <div id="sharesmall" style="position:fixed;right:-7777px;width:100%;top:0;">
      <div class="poster-title" style="border-radius:0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm"/>
      </div>
      <infosmall :recruit="recruitItem" :showShare="true">
        <template #shareSmallImg>
        <div class="txt-r">
        <img :src="codeData2" @load="initCanvas2" @error="initCanvas2" class="qr pr25 pb10"/>
      </div>
      </template>
      </infosmall>
    </div>
    <van-dialog
              v-model="show"
              title="分享到"
              show-cancel-button :showConfirmButton=false
            >
                 <van-row type="flex" justify="center" class="mt19 mb20">
                      <van-col span="9" class="txt-c" @click.native="doShare(1, `${shareId}`)">
                        <p><img class="poster-img" src="../../assets/images/poster/wx.png"/></p>
                        <p class="pt8 f12 pb10">微信</p>
                      </van-col>
                      <van-col span="9" class="txt-c" @click.native="doShare(2, `${shareId}`)">
                        <p><img class="poster-img" src="../../assets/images/poster/pyq.png"/></p>
                        <p class="pt8 f12 pb10">朋友圈</p>
                      </van-col>
                </van-row>
            </van-dialog>
  </div>
</template>

<script>
  import info from '../recruit/info';
  import infosmall from '../recruit/infosmall';
  import api from '../../api';
  import html2canvas from 'html2canvas';
  import recruitItem from '../../components/recruit-item';
  import shopItem from '../../components/shop-item';
  import blankTip from '../../components/blank-tip';
  import recruit from '../../mixins/recruit';
  import shop from '../../mixins/shop';
  import { shareWithApp, launchMiniProgram } from '../../libs/native-app';
  import { convertBase64ToBlob } from '../../libs/util';

  export default {
    name: 'search',
    components: { recruitItem, blankTip, shopItem, info, infosmall },
    mixins: [recruit, shop],
    data() {
      return {
        show: false,
        showCaleInit: true,
        keyWord: '',
        empty: 0,
        active: 0,
        shopempty: 0,
        changeBySearch: false,
        list: [],
        shoplist: [],
        loading: false,
        finished: false,
        shoploading: false,
        shopfinished: false,
        Paging: { PageIndex: 1, PageSize: 10 },
        ShopPaging: { PageIndex: 1, PageSize: 10 },
        hisList: [],
        showInit: true,
        caculate: false,
        pickStatus: 0,
        mapAddress: null,
        showSearchTotal: 0,
        showSearchATotal: 0,
        showSearchBTotal: 0,
        searchItem: '',
        searchResult: {}, // 新接口搜索结果
        tabH: 0,
        titleH: 0,
        recruitItem: { SalaryMin: 0, SalaryMax: 0, PositionUrlList: [] },
        shareType: 0,
        shareId: null,
        codeData: null,
        codeData2: null,
        canvasData: '',
        lastScrollLength: 0,
        userName: '',
        mType: 0
      };
    },
    mounted() {
      setTimeout(() => {
        document.getElementById('pickoversearch').focus();
      }, 300);
      this.getKeyWordList();
      if (this.$route.query.area) {
        this.mapAddress = {};
        this.mapAddress.address = this.$route.query.area;
        if (this.mapAddress.address.length > 8) {
          this.mapAddress.showAddress = this.mapAddress.address.substring(0, 8) + '...';
        } else {
          this.mapAddress.showAddress = this.mapAddress.address;
        }
        this.mapAddress.lng = this.$route.query.lng;
        this.mapAddress.lat = this.$route.query.lat;
      }
    },
    activated() {
      if (this.$store.state.recruit) {
        var findVal = this.list.find(item => {
            return (item.RecruitSysNo * 1) === (this.$store.state.recruit.RecruitSysNo * 1);
        });
        if (findVal) {
          findVal.LeftCount = this.$store.state.recruit.LeftCount;
          findVal.ApplyCount = this.$store.state.recruit.ApplyCount;
          findVal.RecruitInstantStatus = this.$store.state.recruit.RecruitInstantStatus;
          findVal.IsLeaderPick = this.$store.state.recruit.IsLeaderPick;
        }
        this.$store.commit('updateRecruit', null);
      }
    },
    methods: {
      tabChange(index) {
        if (this.pickStatus === index) return;
        this.pickStatus = index;
        // 切换 tab 只切换显示的数据总数，不重新请求接口
        if (this.pickStatus === 0) {
          this.changShowNum(this.showSearchBTotal * 1);
        } else {
          this.changShowNum(this.showSearchATotal * 1);
        }
      },
      getAllList() {
        this.doSearch();
      },
      // 统一搜索方法，一次请求同时获取岗位和门店数据
      async doSearch() {
        try {
          this.showInit = false;
          this.loading = true;
          this.shoploading = true;
          this.showCaleInit = true;
          
          if (!this.keyWord) {
            this.showInit = true;
            this.loading = false;
            this.shoploading = false;
            return;
          }
          
          this.searchItem = this.keyWord;
          
          // 调用搜索接口
          await this.addKeyWord();
          
          // 处理岗位数据
          const recruitVos = this.searchResult.recruitVos || [];
          const recruitCount = this.searchResult.recruitCount || recruitVos.length;
          this.list = recruitVos;
          this.showSearchATotal = recruitCount;
          this.empty = recruitCount === 0 ? 10 : 0;
          this.finished = true; // 一次性获取所有数据
          this.loading = false;
          
          // 处理门店数据
          const storeInfoVos = this.searchResult.storeInfoVos || [];
          const storeInfoCount = this.searchResult.storeInfoCount || storeInfoVos.length;
          // 转换数据格式以适配 shop-item 组件
          this.shoplist = storeInfoVos.map(item => ({
            ShopSysNo: item.id,
            ShopName: item.name,
            ShopLogoUrl: item.imgUrl || item.logo || '',
            ContractAddress: item.address || ''
          }));
          this.showSearchBTotal = storeInfoCount;
          this.shopempty = storeInfoCount === 0 ? 10 : 0;
          this.shopfinished = true; // 一次性获取所有数据
          this.shoploading = false;
          
          // 根据数据情况决定默认显示哪个 tab
          if (this.shoplist.length === 0 && this.list.length > 0) {
            this.active = 1;
            this.pickStatus = 1;
            this.changShowNum(this.showSearchATotal * 1);
          } else {
            this.active = 0;
            this.pickStatus = 0;
            this.changShowNum(this.showSearchBTotal * 1);
          }
          
          this.$nextTick(() => {
            if (this.$refs.searchNav) {
              this.tabH = this.$refs.searchNav.offsetHeight;
            }
            if (this.$refs.titleNav) {
              this.titleH = this.$refs.titleNav.offsetHeight - 9;
              this.tabH += this.titleH;
            }
          });
        } catch (e) {
          this.loading = false;
          this.shoploading = false;
          this.finished = true;
          this.shopfinished = true;
          this.$error(e.message);
        }
      },
      changShowNum(total) {
        this.showSearchTotal = total * 1;
        if (this.showSearchTotal) {
          this.showCaleInit = true;
        } else {
          this.showCaleInit = false;
        }
      },
      // 保留 getList 用于加载更多（如果后续需要分页）
      async getList(bySearch = false, init = false) {
        // 如果已经有数据，不需要重新请求
        if (this.list.length > 0 && !init) {
          this.loading = false;
          return;
        }
        this.doSearch();
      },
      // 保留 getShopList 用于加载更多（如果后续需要分页）
      async getShopList(bySearch = false, init = false) {
        // 如果已经有数据，不需要重新请求
        if (this.shoplist.length > 0 && !init) {
          this.shoploading = false;
          return;
        }
        this.doSearch();
      },
      async getKeyWordList() {
        try {
          let result = await api.get('/api/vpai/vleader/keyword/lastHistoryList');
          // 接口返回的是字符串数组，需要转换为对象数组以适配模板
          const dataList = result.data || [];
          this.hisList = dataList.map(item => ({
            SearchKey: item
          }));
        } catch (e) {
          this.$error(e.message);
        }
      },
      async addKeyWord() {
        try {
          let res = await this.$store.dispatch('postData', {
            url: '/api/vpai/recruit/search_recruit',
            data: {
              keyword: this.keyWord,
              pageNum: 1,
              pageSize: 50
            },
            need_sign: false
          });
          // 保存搜索结果
          this.searchResult = res || {};
          // 更新历史记录
          let temp = this.hisList.filter(v => v.SearchKey === this.keyWord);
          if (!temp.length) {
            this.hisList.unshift({ KeyWordSysNo: res, SearchKey: this.keyWord });
          }
          return res;
        } catch (e) {
          this.$toast(e.errMsg || e.message || e);
          return null;
        }
      },
      async delHis() {
        try {
          this.$loading();
          await this.$store.dispatch('postData', {
            url: '/common/DelKeyWord',
            data: { Body: {} }
          });
          this.hisList = [];
          this.$loadingClose();
        } catch (e) {
          this.$error(e.message);
        }
      },
      async cancel() {
        await this.getKeyWordList();
        this.keyWord = '';
        this.list = [];
        this.goBack();
        // this.showInit = true;
      },
      clickKey(item) {
        this.keyWord = item.SearchKey;
        this.getAllList();
      },
      async getRecruitBySysNo(id) {
        try {
           var findVal = this.list.find(item => {
            return (item.RecruitSysNo * 1) === (id * 1);
          });
          this.recruitItem = findVal;
          // let json = { RecruitSysNo: id };
          // if (this.$store.state.pos) {
          //   json.Latitude = this.$store.state.pos.lat;
          //   json.Longitude = this.$store.state.pos.lng;
          // }
          // let result = await this.$store.dispatch('postData', {
          //   url: '/recruit/GetRecruitBySysNo',
          //   data: { Extra: json }
          // });
          // this.recruitItem = this.processRecruitData(result);
          // console.log(JSON.stringify(this.recruitItem));
          this.getCodeData();
        } catch (e) {
          this.$error(e.message);
        }
      },
      async getCodeData() {
        try {
          this.$loading('获取数据');
          this.codeData2 = null;
          this.codeData = null;
          console.log('');
          const result = await this.$store.dispatch('postData', {
            url: '/liteapp/get-wx-acode-unlimit',
            data: {
              RecruitSysNo: this.recruitItem.RecruitSysNo,
              PersonSysNo: this.$store.state.person.PersonSysNo
            }
          });
          if (this.shareType === 1) {
            this.codeData2 = result;
            console.log(JSON.stringify(this.codeData2));
          } else {
            this.codeData = result;
            console.log(JSON.stringify(this.codeData));
          }
        } catch (e) {
          this.$error(e.message);
        }
      },
      async initCanvas() {
        if (!this.recruitItem.RecruitSysNo) {
          this.$loadingClose();
          return;
        }
        this.initCanvasDraw();
      },
      async initCanvasDraw() {
        setTimeout(() => {
          this.initCanvasDrawDo();
        }, 1000);
      },
      async initCanvasDrawDo() {
        this.$loading('绘制中');
        if (this.shareType === 1) {
            let canvas = await html2canvas(document.getElementById('sharesmall'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          } else {
            let canvas = await html2canvas(document.getElementById('share'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          }
          console.log(this.canvasData);
          console.log('this.canvasData1');
          window.scrollTo(0, this.lastScrollLength);
          this.lastScrollLength = 0;
          this.$loadingClose();
          if (this.shareType > 0) {
            this.share(this.shareType);
          }
      },
      async initCanvas2() {
        if (!this.recruitItem.RecruitSysNo) {
          this.$loadingClose();
          return;
        }
        this.initCanvas2Draw();
      },
      initCanvas2Draw() {
        setTimeout(() => {
          this.initCanvas2DrawDo();
        }, 1000);
      },
      async initCanvas2DrawDo() {
        this.$loading('绘制中');
        if (this.shareType === 1) {
            let canvas = await html2canvas(document.getElementById('sharesmall'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          } else {
            let canvas = await html2canvas(document.getElementById('share'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          }
          console.log(this.canvasData);
          console.log('this.canvasData2');
          window.scrollTo(0, this.lastScrollLength);
          this.lastScrollLength = 0;
          this.$loadingClose();
          if (this.shareType > 0) {
            this.share(this.shareType);
          }
      },
      onConfirm(id) {
        // 当前选择对象的id
        console.log(id);
        this.shareId = id;
        // 直接分享到微信，不再弹出选择框
        this.doShare(1, id);
      },
      async doShare(shareType, id) {
        try {
          this.$loading("准备分享...");
          this.shareType = shareType;

          // 从列表中找到当前招聘项
          const recruitItem = this.list.find((item) => {
            return item.id * 1 === id * 1;
          });

          if (!recruitItem) {
            this.$loadingClose();
            this.$toast("未找到招聘信息");
            return;
          }

          // 1. 调用接口获取分享追踪令牌
          const tokenResult = await api.get("/api/share/create_share_token", {
            params: {
              recruitDispatchRecordId: recruitItem.recruitDispatchRecordId || "",
              recruitId: recruitItem.id || "",
            },
          });

          // 获取追踪Token
          let trackToken = "";
          if (tokenResult.code === 10000 && tokenResult.data) {
            trackToken = tokenResult.data;
          }
          console.log("分享追踪Token:", trackToken);

          // 检查环境
          const ua = navigator.userAgent;
          const isWxmp = ua.toLowerCase().indexOf('miniprogram') > -1;

          if (shareType === 1) {
            // 微信好友分享
            if (isWxmp) {
              // 小程序环境：跳转到小程序分享页面
              launchMiniProgram({
                appId: "wxbb140f2dced7d207",
                path: `subPackages/aboutPost/pages/post_detail/share?id=${id}&shareToken=${trackToken}&shareFlag=true`,
                envVersion: "trial",////release
              });
              this.$loadingClose();
              this.show = false;
              return;
            } else {
              // APP环境：分享小程序卡片
              const miniPath = `subPackages/aboutPost/pages/post_detail/share?id=${id}&shareToken=${trackToken}&IsFromShare=1`;
              const shareObj = {
                shareMedia: 3, // 3-小程序卡片
                shareType: 1, // 1-微信好友
                title: `就业队长招聘${recruitItem.title || ""}`,
                imgUrl: recruitItem.storePhotos || "",
                imageUrl: recruitItem.storePhotos || "",
                userName: "gh_49bd5402050d",
                path: miniPath,
                mType: 0, // 0-正式版
              };
              await shareWithApp(shareObj);
              this.$loadingClose();
              this.show = false;
              return;
            }
          } else if (shareType === 2) {
            // 朋友圈分享 - 使用海报分享流程
            this.recruitItem = recruitItem;
            this.getCodeData();
          }
        } catch (e) {
          this.$loadingClose();
          this.show = false;
          console.error("分享失败:", e);
          this.$toast(e.message || "分享失败");
        }
      },
      async share(index) {
        try {
          if (!this.recruitItem.RecruitSysNo) {
            return;
          }
          this.$loading('分享中');
          this.$loading('请稍后', 3000);
          await this.$store.dispatch('postData', {
            url: '/recruit/LeaderPickRecruit',
            data: {
              Body: {
                RecruitSysNo: this.recruitItem.RecruitSysNo,
                PersonSysNo: this.$store.state.person.PersonSysNo
              }
            }
          });
          var findVal = this.list.find(item => {
            return (item.RecruitSysNo * 1) === (this.recruitItem.RecruitSysNo * 1);
          });
          if (findVal) {
            findVal.IsLeaderPick = 1;
          }
          if (index === 1) {
            this.getShareData(this.recruitItem.RecruitSysNo);
          } else {
            try {
              await shareWithApp({
                imgUrl: this.canvasData,
                shareType: index,
                shareMedia: 2
              });
            this.$loadingClose();
            } catch (e) {
              this.show = false;
              this.$toast(e.message);
            }
          }
        } catch (e) {
          this.$toast(e.message);
        }
      },
      async getShareData(id) {
        try {
          // 获取分享参数
          if (!this.userName) {
            let res = await this.$store.dispatch('postData', {
              url: '/recruit/GetShareData',
              data: {}
            });
            console.log('getShareData:', res);
            this.userName = res.username;
            this.mType = parseInt(res.mtype);
            this.doShareLittleApp(id);
          } else {
            this.doShareLittleApp(id);
          }
        } catch (e) {
          this.$toast(e);
        }
      },
      async doShareLittleApp(id) {
          let file = convertBase64ToBlob(this.canvasData);
          let formData = new FormData();
          formData.append('folder', 'authen');
          formData.append('file[]', file);
          const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
          };
          let ossRes = await api.post(`/upload/upload-images`, formData, config);
          console.log(ossRes.Data[0].url);
          if (ossRes && ossRes.Data && ossRes.Data.length > 0) {
            // 分享小程序卡片
              let path = '';
              path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.PersonSysNo}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
              // if (this.$store.state.person.LeaderPersonSysNo) {
              //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.LeaderPersonSysNo}&FromPersonSysNo=${this.$store.state.person.LeaderPersonSysNo}&IsFromShare=1&t=2`;
              // } else {
              //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
              // }
              let shareObj = {
                shareMedia: 3,
                shareType: 1,
                imgUrl: ossRes.Data[0].url,
                imageUrl: ossRes.Data[0].url,
                link: 'http://www.baidu.com',
                title: `大圣抢班招聘${this.recruitItem.PositionName}`,
                userName: this.userName,
                path: path,
                mType: this.mType
              };
              try {
              await shareWithApp(shareObj);
              this.$loadingClose();
            } catch (e) {
              this.show = false;
              this.$toast(e.message);
            }
          } else {
            this.$loadingClose();
          }
      }
    }
  };
</script>
<style lang="less" scoped>
  @import '../../assets/css/theme.less';
.srarchTabs .van-tabs__wrap{ top:0px; }
  .ds-search-wrap {
    background: @primaryColor !important;
    padding-bottom: 20px;
  }
  // .van-tabs__nav--line {
  //   padding-bottom: 0.38rem;
  // }
  .search-content-pull-active {
    overflow: visible;
  }

  .ds-search-content {
    background: @white;
    border-radius: 10px 10px 0 0;
    box-sizing: border-box;
    overflow-y: auto;
    padding-bottom: 2.66667vw;
    -webkit-overflow-scrolling: touch;
  }
  .ds-search-content-cale {
    height: calc(~"100vh - 49.3vw");
  }

  .search-show-history {
    margin-top: -80px;
  }
  .search-un-show-history {
    // margin-top: -8px;
  }

  .ds-search-content .van-list {
    margin-bottom: 10px;
  }
  .search .ds-job-list-box{margin:0px 12px 10px 12px;}
  .ds-search-list span {
    display: inline-block;
    font-size: 12px;
    color: @c666;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding: 0 15px;
    margin: 0 10px 10px 0;
    background: @bgLightGray;
  }

  .ds-search-list-b span {
    background: transparent;
  }

  // .van-tabs__content {
  //   background: @bgGray;
  // }

  .poster-title {
    height: 41px;
    line-height: 41px;
    border-radius: 5px 5px 0 0;
    background: linear-gradient(146deg, rgba(255, 134, 58, 1) 0%, rgba(253, 100, 4, 1) 100%);
  }

  .poster-logo {
    height: 40px;
    width: auto;
    margin-left: 10px;
  }

  .ds-divider-title {
    position: relative;
    overflow: hidden;
  }

  .ds-divider-title::after {
    content: '';
    position: absolute;
    height: 1PX;
    background: @borderColor;
    top: 50%;
    left: 0;
    width: 100%;
  }

  .ds-divider-title > h3, .ds-divider-title > p {
    background: @white;
    z-index: 2;
    position: relative;
  }

  .qr {
    width: 110px;
    height: 110px;
  }

  .poster-img {
    width: 44px;
    height: 44px;
  }

  .ds-list-divider > span {
    background: @bgGray
  }

  .new-search{ padding-top: 49.3vw;}
  .new-search .van-nav-bar{ position: absolute; z-index: 2; top: 0; left: 0; width: 100%;}
  .search-form{ position: absolute; z-index: 2; top: 12.26667vw; left: 0; width: 100%; height: 17vw;}
  .srarchTabs{ position: absolute; z-index: 2; top: 29.26667vw;left: 0; width: 100%; }

  .page-fixed{ height: 100vh; overflow: hidden;}

</style>
